import PhishingIcon from '../../../Layout/Components/PhishingIcon';
import React, {Fragment} from "react";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Row, Col, Card, CardBody, CardTitle, Input, Button, Spinner, Alert, Nav, NavItem, NavLink  } from 'reactstrap';

import PageTitle from '../../../Layout/Components/PageTitle';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import LandingPageModal from './LandingPageModal';
import LandingPageTable from './LandingPageTable';
import classnames from 'classnames';

import {getlandingpages,getLandingPage,deleteLandingPage} from "../../../API/PhishingAPI";
import {lpReactTableConfiguration_ForLandingPage, lpReactTableConfiguration_ForImportScreen} from "./LPColumnGenerator"
import PhishingDataTable from '../PhishingDataTable'
import TemplateGallery from '../TemplateGallery/TemplateGallery';

export class LandingPage extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      openEdit: false,
      landingPage: {},
      landingPageList: [],
      isLoaded: false,
      error: "",
      errorFetchingData: false,
      activeTab: 1,
      datasets: {
        1: {
          data: null,
          dataFetchFunc: getlandingpages,
          config: lpReactTableConfiguration_ForLandingPage
        },
        2 : {
          data: null,
          dataFetchFunc: () => getlandingpages({domain: "0.template"}),
          config: lpReactTableConfiguration_ForImportScreen
        }
      }
    };
    this.onEditOrCopyCallback = this.onEditOrCopyCallback.bind(this);
    this.onSubmitCallback = this.onSubmitCallback.bind(this);
    this.loadLandingPageList = this.loadLandingPageList.bind(this);
    this.deleteLandingPage = this.deleteLandingPage.bind(this);
    this.addPolicyCallback = this.addPolicyCallback.bind(this);
    this.setDataForActiveTab = this.setDataForActiveTab.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
  }

  async onEditOrCopyCallback(item, copiedVersion) {
    if (this.loadingDetail) return;
    this.loadingDetail = true;
    try {
      const content = String(this.state.activeTab) === '2'
        ? await getLandingPage(item.id, {domain: '0.template'}) : item;
      if (!this.unmounted) this.setState({
        openEdit: true,
        landingPage: content,
        copiedVersion
      });
    } catch (error) {
      toast.error('Error loading template');
    } finally {
      this.loadingDetail = false;
    }
  }

  onSubmitCallback(){
    this.loadLandingPageList('1');
  }
  componentDidMount() {
    this.loadLandingPageList('1');
    // Warm the small shared catalog while the user views their own templates.
    this.loadLandingPageList('2');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  loadLandingPageList(tab = String(this.state.activeTab)) {
    const dataset = this.state.datasets[tab];
    if (this.pendingLoads?.[tab]) return this.pendingLoads[tab];
    this.pendingLoads = this.pendingLoads || {};
    this.setState(updater => ({
      datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], loading: true, error: null}}
    }));
    const request = dataset.dataFetchFunc().then(items => {
      const data = items.map(item => ({...item,
        modified_date: new Date(item.modified_date).toLocaleString(undefined, {dateStyle:'full', timeStyle:'medium'})
      }));
      if (!this.unmounted) this.setState(updater => ({
        datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], data, loading: false}}
      }));
    }).catch(error => {
      if (!this.unmounted) this.setState(updater => ({
        datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], loading: false, error: 'Error fetching data'}}
      }));
    }).finally(() => { delete this.pendingLoads[tab]; });
    this.pendingLoads[tab] = request;
    return request;
  }

  deleteLandingPage(e){
    const id = e._original.id;
    deleteLandingPage(id)
      .then(res => {
        this.setDataForActiveTab();
        this.toggleTab(1);
      }).catch(error => {
        toast["error"](this.props.t("deleting", { element: 'Landing Page', message: error.message }));
      })
  }
  setDataForActiveTab(data) {
    const tab = String(this.state.activeTab);
    this.setState(updater => ({
      datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], data}}
    }));
  }
  render(){
    const { t, i18n } = this.props;
    const editLandingPageModal = this.state.openEdit &&
      <LandingPageModal open={true} showOpenButton={false} onClose={this.addPolicyCallback}
      landingPage={this.state.landingPage} copiedVersion={this.state.copiedVersion} onSubmit={this.onSubmitCallback}/>

    const{datasets, activeTab} = this.state;
    const activeData = datasets[activeTab].data;
    const activeConfig = datasets[activeTab].config;

    return (
      <Fragment>
        {!this.props.componentsOnly && <PageTitle
          heading={t("landing_page.title")}
          icon={<PhishingIcon name="templates" />}
        />}
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="12" sm="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <LandingPageModal open={this.state.open} onClose={this.addPolicyCallback} onSubmit={this.onSubmitCallback}/>
                  {editLandingPageModal}
                  {this.state.errorFetchingData? <Alert color="danger">
                  {this.state.error}
                  </Alert> :
                  <div className="mt-3">
                    <Nav tabs>
                      <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab == '1' })} onClick={() => this.toggleTab('1')}>My Page</NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab == '2' })} onClick={() => this.toggleTab('2')}>Other Pages</NavLink>
                      </NavItem>
                    </Nav>
                    {String(activeTab) === '2' && !this.props.componentsOnly ? <TemplateGallery kind="page" items={activeData}
                      loading={datasets[activeTab].loading} error={datasets[activeTab].error}
                      onRetry={() => this.loadLandingPageList('2')}
                      onImported={() => { this.onSubmitCallback(); this.toggleTab('1'); }} /> : activeData ?
                      <PhishingDataTable key={activeTab} config={activeConfig}  data={activeData} onEditOrCopy={this.onEditOrCopyCallback} onDelete={this.deleteLandingPage}/>
                      : datasets[activeTab].error ? <Alert color="danger">{datasets[activeTab].error}
                      <Button color="link" onClick={() => this.loadLandingPageList()}>Retry</Button>
                    </Alert> : <div><Spinner color="primary" /> Data is loading!!!</div>}
                  </div>
                }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    )
  }
  addPolicyCallback(){
    this.setState({
      openEdit: false,
      landingPage:{}
    }, () => {
      this.toggleTab(1);
    })
  }
  toggleTab(tabActivatedNum) {
    const tab = String(tabActivatedNum);
    this.setState({activeTab: tab}, () => {
      if (!this.state.datasets[tab].data) this.loadLandingPageList(tab);
    });
  }
}
export default withTranslation()(LandingPage);
